import styled from "styled-components"

const Bold = styled.span`
  font-weight: bold;
`;

export default Bold;